import { useEffect, useState, useCallback } from 'react'
import { apiGet, apiPatch } from '../api'
import type { TaskRow } from '../api'

export default function TaskList() {
  const [tasks, setTasks] = useState<TaskRow[]>([])

  const load = useCallback(async () => {
    try {
      const res = await apiGet<{ tasks: TaskRow[] }>('/tasks?status=open')
      setTasks(res.tasks)
    } catch { /* ignore */ }
  }, [])

  useEffect(() => {
    load()
    const t = setInterval(load, 5 * 60_000)
    return () => clearInterval(t)
  }, [load])

  const grouped = tasks.reduce<Record<string, TaskRow[]>>((acc, t) => {
    const key = t.repo_label
    if (!acc[key]) acc[key] = []
    acc[key]!.push(t)
    return acc
  }, {})

  const close = async (id: string) => {
    setTasks(prev => prev.filter(t => t.id !== id))
    try { await apiPatch(`/tasks/${id}`, { status: 'done' }) } catch { load() }
  }

  return (
    <section className="panel work-panel">
      <div className="panel-header">
        <span>Open tasks</span>
        <span className="mono">{tasks.length}</span>
      </div>
      {tasks.length === 0 && <div className="empty-state">No open TASK_*.md items found.</div>}
      <div className="task-list">
        {Object.entries(grouped).map(([repo, items]) => (
          <details key={repo} className="task-group" open>
            <summary>
              {repo} <span className="muted">· {items.length}</span>
            </summary>
            {items.map(t => (
              <div key={t.id} className="task-row" title={`${t.task_file}:${t.line_number}`}>
                <label>
                  <input type="checkbox" onChange={() => close(t.id)} />
                  <span>{t.title}</span>
                </label>
              </div>
            ))}
          </details>
        ))}
      </div>
    </section>
  )
}
